import React from "react";

function AttendanceList(props) {
  return (
    <table className="table text-center table-bordered table-striped">
      <thead className="tt-group-header">
        <tr>
          <th className="text-center">
            <input
              type="checkbox"
              style={{ position: "relative", top: "3px" }}
              name="checkAll"
              onChange={props.checkAllStudents}
              checked={props.checkedAllStudents}
              disabled={props.students.some((s) => s.attendanceId)}
            />
          </th>
          <th>Student</th>
          <th>Remarks</th>
        </tr>
      </thead>
      <tbody>
        {props.students && props.students.length > 0 ? (
          props.students.map((student) => {
            return (
              <React.Fragment key={student.admissionId}>
                <tr>
                  <td>
                    <input
                      type="checkbox"
                      name="isPresent"
                      onChange={(e) => props.studentAttendanceChange(e, student.admissionId)}
                      checked={student.isPresent}
                      disabled={student.attendanceId}
                    />
                  </td>
                  <td>{student.people.name}</td>
                  <td>
                    <input
                      type="textarea"
                      name="remarks"
                      onChange={(e) => props.studentAttendanceChange(e, student.admissionId)}
                      value={student.remarks}
                      disabled={student.attendanceId}
                    />
                  </td>
                </tr>
              </React.Fragment>
            );
          })
        ) : (
          <tr>
            <td colSpan="3">No Students</td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

export default AttendanceList;
